import { useEffect, useRef, useState } from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const Profile = ({ ...props }) => {
    const refInput = useRef(null);

    const { heading, heading_img, subheading, inputs, button } = props;
    const { formData, fn } = props;

    useEffect(() => {
        refInput.current?.focus();
    }, []);

    const handleSetProfile = (name, value) => {
        formData[name] = value;
        fn.handleFormChange(formData)
    };

    return (
        <div className="component-profile">
            <HeadingOne image={heading_img} heading={heading} />

            <Card>
                <CardHeader>
                    <h2 className="mb-0">{subheading}</h2>
                </CardHeader>
                <CardBody>
                    <div className="row items-end">
                        <div className="col lg:w-3/12">
                            {formData?.image ? (
                                <div className="profile-image">
                                    <img src={formData.image.path} />
                                </div>
                            ) : (
                                <div className="profile-image-placeholder">Foto</div>
                            )}
                        </div>
                        <div className="col lg:w-9/12">
                            <div className="form-group">
                                <input ref={refInput} onChange={(e) => handleSetProfile(e.target.name, e.target.value)} value={formData?.name ?? ''} name="name" placeholder="Zadejte název profilu" className="input-control" />
                            </div>
                            <div className="form-group">
                                {formData?.bio ? (
                                    <div className="profile-bio">{formData.bio.text}</div>
                                ) : (
                                    <div className="profile-bio-placeholder">BIO</div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row justify-center mt-10">
                        <div className="col lg:w-8/12">
                            <div>
                                <div>
                                    <h3 className="h2 my-10 text-center">{inputs.image.label}</h3>
                                    <div className="row">
                                        {inputs.image.items.map((item, index) => (
                                            <div className="col w-1/2 lg:w-3/12">
                                                <div
                                                    onClick={() => handleSetProfile('image', item)}
                                                    className={'profile-image-handle' + (formData?.image?.id == item.id ? ' --selected' : '')}
                                                >
                                                    <img src={item.path} className="h-full w-full object-cover" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div>
                                    <h3 className="h2 my-10 text-center">{inputs.bio.label}</h3>
                                    <div className="row">
                                        {inputs.bio.items.map((item, index) => (
                                            <div className="col lg:w-6/12">
                                                <div
                                                    onClick={() => handleSetProfile('bio', item)}
                                                    className={'profile-bio-handle' + (formData?.bio?.id == item.id ? ' --selected' : '')}
                                                >
                                                    {item.text}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </CardBody>
                <CardFooter>
                    {button && (
                        <div className="mt-12">
                            <Button {...button} onClick={() => fn.handleAction(button.action)} />
                        </div>
                    )}
                </CardFooter>
            </Card>
        </div>
    );
};

export default Profile;
